import { OutputBlockData } from '@editorjs/editorjs';

import { extractCleanText } from './utils';

export const parseHeader = (element: Element): OutputBlockData[] => {
  const cleanText = extractCleanText(element);

  if (!cleanText) return [];

  return [
    {
      type: 'header',
      data: {
        text: cleanText,
        level: 5,
      },
    },
  ];
};
